import React from 'react';
import type { IconProps } from '../Icon/types';
/* istanbul ignore file */
function IconDocumentDefault({
  srText,
  size = 'md',
  className = '',
  ...props
}: IconProps) {
  const newClassName = `mc-icon mc-icon--${size} ${className}`;
  return <>{!!srText && <span className='mc-sr-only'>{srText}</span>}<svg xmlns="http://www.w3.org/2000/svg" width={25} height={25} fill="none" viewBox="0 0 24 24" aria-hidden="true" role="img" className={newClassName} {...props}><path fill="currentColor" fillRule="evenodd" d="M9.195 4.5c-.526 0-.952.448-.952 1v14c0 .552.426 1 .952 1h7.62c.525 0 .951-.448.951-1v-8h-3.81c-1.051 0-1.904-.895-1.904-2v-5zm4.762.896V9.5h3.808a1.02 1.02 0 0 0-.303-.684zm-7.62.104c0-1.657 1.28-3 2.858-3h3.47c.72 0 1.416.287 1.944.802l4.15 4.048c.582.568.912 1.364.912 2.198V19.5c0 1.657-1.279 3-2.857 3H9.195c-1.578 0-2.857-1.343-2.857-3z" clipRule="evenodd" /></svg></>;
}
export default IconDocumentDefault;